import React from 'react'
import NewsFeedIcon from "./../../assets/NewsfeedIcon.svg"
import NewsFeedActiveIcon from "./../../assets/NewsfeedActive.svg"
import MenuIcon from "./../../assets/MenuIcon.svg"
import MenuActive from "./../../assets/MenuActive.svg"
import ProspectsIcon from "./../../assets/ProspectsIcon.svg"
import ProspectsActive from "./../../assets/ProspectsActive.svg"
import ProfileIcon from "./../../assets/Profile.svg";
import Tags from "./../../assets/Tags.svg";
import SettingsIcon from "./../../assets/Settings.svg";
import TeamMembersIcon from "./../../assets/TeamMembers.svg";
import SyncIcon from "./../../assets/SyncIcon.svg";
import { Icons } from '../../design_system/components/Icons';
import LogOutIcon from "./../../assets/LogOut.svg";
import { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useEffect } from 'react'
import ConditionalRender from '../../ConditionalRender'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import Cookies from 'universal-cookie'
import { updateCurrentTeam } from '../../redux/currentTeamSlice'
import { removeSharedCookie } from '../../config/cookiesSettings'
import useCheckUserAccess from '../custom_hooks/useCheckUserAccess'
import { canUseAnyExport, canUseMemberManagementAction, canViewFeedType } from '../../utils/access'
import DownloadIcon from './../../assets/Download.svg'

const FOOTER_TABS = {
    NewsFeed: {
        activeClass: "text_link",
        activeIcon: NewsFeedActiveIcon,
        Icon: NewsFeedIcon
    },
    ProspectList: {
        activeClass: "text_link",
        activeIcon: ProspectsActive,
        Icon: ProspectsIcon
    }
}

const PostAuthMobileFooter = (props) => {

    const current_user = useSelector((state) => state.current_user.user);
    const current_team = useSelector((state) => state.current_team.team);
    const _dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("");
    const _history = useHistory();
    const checkUserAccess = useCheckUserAccess();
    const canInviteMembers = canUseMemberManagementAction({
        permissionKey: "members.invite",
        user: current_user,
        team: current_team,
    });
    const canViewDataExports = canUseAnyExport({
        team: current_team,
        legacyAllowed: checkUserAccess("page_data_exports"),
    });
    const canViewMapper = current_team.displayable_features?.display_mapper_suggestions === true;
    const canViewAnyFeed = canViewFeedType({ typeKey: "all", team: current_team, user: current_user });

    useEffect(() => {
        if (_history.location.pathname == "/feed") setActiveTab("NewsFeed");
        else if (_history.location.pathname == "/prospects") setActiveTab("ProspectList");;
        const unlisten = _history.listen(() => {
            if (_history.location.pathname == "/feed") setActiveTab("NewsFeed");
            else if (_history.location.pathname == "/prospects")
                setActiveTab("ProspectList");
            else setActiveTab("");
        });
        return unlisten;
    }, []);

    const handleSwitchAccount = () => {
        const cookies = new Cookies();
        removeSharedCookie(cookies, "team_id");
        _dispatch(updateCurrentTeam({}));
        _history.push("/switch_acc");
    };

    const renderHamburgerMenu = () => {
        return (
            <div className="mobile_overlay_container mobile-footer__overlay">
                <Link
                    to={`/profile/${current_user.id || current_user.api_key}`}
                    className="login_drop_link"
                >
                    <img
                        src={ProfileIcon}
                        className="login_drop_icon"
                    ></img>
                    <div>Profile</div>
                </Link>
                <a
                    className="login_drop_link"
                    onClick={() => window.dispatchEvent(new CustomEvent('open-settings', { detail: { tab: 'profile' } }))}
                >
                    <img
                        src={SettingsIcon}
                        className="login_drop_icon"
                    ></img>
                    <div>Settings</div>
                </a>
                <Link
                    to="/manage/tags"
                    className="login_drop_link"
                >
                    <img
                        src={Tags}
                        className="login_drop_icon"
                    ></img>
                    <div>Tags/Labels</div>
                </Link>
                <ConditionalRender if={canViewMapper}>
                    <Link to="/mapper-suggestions" className="login_drop_link">
                        <Icons name="mapper-suggestions" size={16} className="login_drop_icon" aria-hidden="true" />
                        <div>Mapper Suggestions</div>
                    </Link>
                </ConditionalRender>
                <ConditionalRender if={canViewDataExports}>
                    <a className="login_drop_link" onClick={() => window.dispatchEvent(new CustomEvent('open-data-exports'))}>
                        <img src={DownloadIcon} className="login_drop_icon" alt="" />
                        <div>Data exports</div>
                    </a>
                </ConditionalRender>
                <ConditionalRender if={canInviteMembers}>
                    <a
                        className="login_drop_link"
                        onClick={() => window.dispatchEvent(new CustomEvent('open-settings', { detail: { tab: 'people' } }))}
                    >
                        <img
                            src={TeamMembersIcon}
                            className="login_drop_icon"
                        ></img>
                        <div>Team members</div>
                    </a>
                </ConditionalRender>
                <ConditionalRender if={current_user.is_super_admin}>
                    <Link
                        to="/admin/panel"
                        className="login_drop_link"
                    >
                        <img
                            src={TeamMembersIcon}
                            className="login_drop_icon"
                        ></img>
                        <div>Super Admin Panel</div>
                    </Link>
                </ConditionalRender>

                <div className="mobile-footer__divider"></div>

                <a className="login_drop_link"
                    onClick={handleSwitchAccount}
                >
                    <img
                        src={SyncIcon}
                        className="login_drop_icon"
                    ></img>
                    <div>Switch Accounts</div>
                </a>
                <a className="login_drop_link"
                    onClick={props.logout}
                >
                    <img
                        src={LogOutIcon}
                        className="login_drop_icon"
                    ></img>
                    <div>Logout</div>
                </a>
            </div>
        )
    }
    return (
        <>

            {activeTab == "Menu" && renderHamburgerMenu()}
            <div className="mobile_footer_container flex_container_space_between">
                <ConditionalRender if={canViewAnyFeed}>
                    <Link to="/feed" className="text-center no_decoration mobile-footer__tab">
                        <img src={activeTab == "NewsFeed" ? NewsFeedActiveIcon : NewsFeedIcon}></img>
                        <div className={activeTab == "NewsFeed" ? "text_link" : "text_body"}>News feed</div>
                    </Link>
                </ConditionalRender>
                <Link to="/prospects" className="text-center no_decoration mobile-footer__tab">
                    <img src={activeTab == "ProspectList" ? ProspectsActive : ProspectsIcon}></img>
                    <div className={activeTab == "ProspectList" ? "text_link" : "text_body"}>Prospects</div>
                </Link>
                <div className="text-center mobile-footer__tab" onClick={() => setActiveTab(state => (state === "Menu" ? "" : "Menu"))}>
                    <img src={activeTab == "Menu" ? MenuActive : MenuIcon}></img>
                    <div className={activeTab == "Menu" ? "text_link" : "text_body"}>Menu</div>
                </div>

            </div>
        </>
    )
}

export default PostAuthMobileFooter
